"use strict";
/**
 * POST /positions wire types (ai/POSITION_CACHE_PLAN.md §5): the order page's
 * one position read per poll, shared by the server route and the client.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSITION_VENUES = exports.CLOSE_SKIPPED_WARNING = void 0;
/**
 * A buy that asked to close opposite but couldn't read that position went out
 * alone (ai/POSITION_CACHE_PLAN.md K3): the entry beats the close, and the
 * operator must be told the opposite side is still held.
 */
exports.CLOSE_SKIPPED_WARNING = "Bought, but the opposite position could not be read, so it was not closed.";
exports.POSITION_VENUES = ["kalshi", "pm-us", "novig"];
